import { NavLink } from "react-router-dom";
import {
	HomeRounded,
	LockOpenRounded,
	ExitToAppRounded,
	MenuBookRounded,
} from "@material-ui/icons";
import { Button } from "@material-ui/core";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useBouncyShadowStyles } from '@mui-treasury/styles/shadow/bouncy';

import { useState, useEffect } from "react";
import { Logout } from "./User/Logout";
import { connect } from "react-redux";

export const Navbar = (props) => {
	const [user, setUser] = useState({});
	const [search, setSearch] = useState("Search for Recipe");
	const [recipes, setRecipes] = useState(props);

	const handleChange = (e) => {
		setSearch(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(search);
		console.log(recipes);
		console.log(props);
	};

	useEffect(() => {
		setInterval(() => {
			const token = localStorage.getItem("token");

			setUser(token);
		}, [user]);
	});

	useEffect(() => {
		setRecipes(props);
	}, [props]);


	const useStyles = makeStyles(() => ({
		root: {
			maxWidth: 304,
			margin: 'auto',
			boxShadow: 'none',
			borderRadius: 0,
		},
		content: {
			padding: 24,
		},
		cta: {
			marginTop: 24,
			textTransform: 'initial',
		},
	}));
	
	const shadowStyles = useBouncyShadowStyles();
	

	return (
		<div className="navbar">
			<NavLink to="/">
				<Button
					variant="contained"
					color="primary"
					startIcon={<HomeRounded />}
					className={cx(useStyles.root, shadowStyles.root, "navbutton")}
				>
					Home
				</Button>
			</NavLink>{' '}

			<NavLink to="/recipebook">
				<Button
					variant="contained"
					color="primary"
					className={cx(useStyles.root, shadowStyles.root, "navbutton")}
					startIcon={<MenuBookRounded />}
				>
					Recipe Book
				</Button>
			</NavLink>{' '}

			{user ? (
				<span>
					<NavLink to="/">
						<Button
							variant="contained"
							color="primary"
							className={cx(useStyles.root, shadowStyles.root, "navbutton")}
							startIcon={<ExitToAppRounded />}
							onClick={Logout}
						>
							Logout
						</Button>
					</NavLink>{' '}
				</span>
			) : (
				<NavLink to="/login">
					<Button
						variant="contained"
						color="primary"
						className={cx(useStyles.root, shadowStyles.root, "navbutton")}
						startIcon={<LockOpenRounded />}
					>
						Login
					</Button>
				</NavLink>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	recipes: state.recipeReducer,
});

export default connect(mapStateToProps)(Navbar);
